/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
export const CornerSmall = {'borderRadius': '2px'};
export const CornerMedium = {'borderRadius': '4px'};
export const CornerLarge = {'borderRadius': '8px'};
export const CornerExtraLarge = {'borderRadius': '16px'};
export const CornerFull = {'borderRadius': '100%'};